/* eslint-disable */
export default {
  dial: '撥打',
  message: '訊息',
  transfer: '轉接',
} as const;

// @key: @#@"dial"@#@ @source: @#@"Dial"@#@
// @key: @#@"message"@#@ @source: @#@"Message"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
